module.exports = __webpack_public_path__ + "img/city (7).75a67ea1.png";